import api from './index'

export function getBrandList(params) {
  return api.get('/api/v1/brand', { params })
}

export function getBrandDetail(brandCode) {
  return api.get(`/api/v1/brand/${brandCode}`)
}

export function createBrand(data) {
  return api.post('/api/v1/brand', data)
}

export function updateBrand(brandCode, data) {
  return api.put(`/api/v1/brand/${brandCode}`, data)
}

export function toggleBrandActive(brandCode) {
  return api.post(`/api/v1/brand/${brandCode}/active`)
}

export function deleteBrand(brandCode) {
  return api.delete(`/api/v1/brand/${brandCode}`)
}
